// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { copyButtonPlugin } from '@atlaskit/editor-plugin-copy-button';
export type { CopyButtonPlugin, CopyButtonPluginState } from '@atlaskit/editor-plugin-copy-button';
